import { render } from "./ui-modal.vue?vue&type=template&id=3599d2c1"
import script from "./ui-modal.vue?vue&type=script&lang=js"
export * from "./ui-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__